import { ReactElement } from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';

import NoDataFound from '~/ui/components/reusable/NoDataFound';
import Item from './Item';

import { IPagePermissions } from '../types';
import { IProgramList } from '~/services/api/programs/types';
import styles from './List.module.scss';

interface IProps {
  programs: IProgramList[];
  permissions: IPagePermissions;
  onRemoveProgram: (program: IProgramList) => void;
}

const List = ({ programs, permissions, onRemoveProgram }: IProps): ReactElement => (
  <Paper elevation={0}>
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell width={130} align="center">
              Time Zone
            </TableCell>
            <TableCell width={100} align="center">
              Users
            </TableCell>
            <TableCell width={110} align="center">
              Patients
            </TableCell>
            <TableCell width={340} align="center" />
            <TableCell width={55} align="center" />
            {permissions.canRemoveProgram && <TableCell width={55} align="center" />}
          </TableRow>
        </TableHead>
        <TableBody>
          {programs.length ? (
            programs.map(item => (
              <Item
                key={item.id}
                program={item}
                permissions={permissions}
                onRemove={onRemoveProgram}
              />
            ))
          ) : (
            <TableRow>
              <TableCell
                className={styles.emptyCell}
                colSpan={permissions.canRemoveProgram ? 7 : 6}
              >
                <NoDataFound title="There are no programs" />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);

export default List;
